'use client';

import { useRecoilValue } from 'recoil';
import { selectedProjectDataState } from 'lib/state';
import SocialIcons from 'components/SocialIcons';
import ProjectTitleSkeleton from 'components/ProjectTitleSkeleton';

export default function ProjectTitle({ project }) {
  const clientProject = useRecoilValue(selectedProjectDataState);

  if (!(project || clientProject)) {
    return <ProjectTitleSkeleton />;
  }

  const { name, discord, twitter, homepage } = project || clientProject;
  return (
    <div className="flex items-center space-x-6">
      <p className="text-h2 md:text-h1 font-semibold">{name}</p>
      <SocialIcons discord={discord} twitter={twitter} homepage={homepage} />
    </div>
  );
}
